/**
 * Sudanese pound.
 */
export var SDG = {
  code: 'SDG',
  base: 10,
  exponent: 2
};